import { render, staticRenderFns } from "./ReceiptEmailPage.vue?vue&type=template&id=91add5b8&scoped=true&lang=html&"
import script from "./ReceiptEmailPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptEmailPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptEmailPage.vue?vue&type=style&index=0&id=91add5b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91add5b8",
  null
  
)

export default component.exports